export default __webpack_public_path__ + "static/media/app-icon.0d419cfd.png";